export default "__VITE_ASSET__ac4594f9__"